import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceDetectorResult } from 'device-detector-js';
import { Observable } from 'rxjs';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class ApiService {

  constructor(private http: HttpClient) { }

  getDevice(): Observable<DeviceDetectorResult> {
    return this.http.get<DeviceDetectorResult>('/api/device')
  }

  otpSMSGen(path: string, otpSMSGen: OTPSMSGen): Observable<OTPSMSRes> {
    return this.http.post<OTPSMSRes>(path, otpSMSGen)
  }

  resendOTPSMS(path: string, resendOTPSMS: ResendOTPSMS): Observable<OTPSMSRes> {
    return this.http.post<OTPSMSRes>(path, resendOTPSMS)
  }

  otpSMSValidate(path: string, otpSMSValidate: OTPSMSValidate): Observable<OTPSMSRes> {
    return this.http.post<OTPSMSRes>(path, otpSMSValidate)
  }
}

export interface OTPSMSGen {
  action: '1',
  countryCode: string,
  formId: string,
  mobileNo: string,
  prdName: string
}

export interface OTPSMSRes {
  status: string,
  serviceId: string,
  errorCode?: string,
  errorMessage?: string
}

export interface ResendOTPSMS {
  action: '3',
  countryCode: string,
  serviceId: string
}

export interface OTPSMSValidate {
  action: '2',
  countryCode: string,
  otp: string,
  serviceId: string
}